import z from 'zod';

import { CreditUsageType } from '../types/Credits';

export const CreditSpendLeaderboardQuery = z.object({
    start: z.coerce.date(),
    end: z.coerce.date(),
    includeInternal: z
        .preprocess(
            (value) =>
                typeof value === 'string' ? (value === 'true' ? true : value === 'false' ? false : undefined) : value,
            z.boolean(),
        )
        .optional(),
});

export type CreditSpendLeaderboardQuery = z.infer<typeof CreditSpendLeaderboardQuery>;

export type CreditUsageBreakdown = Partial<Record<CreditUsageType, number>>;

export type CreditSpendByUser = {
    userId: string | null;
    userName: string | null;
    userEmail: string | null;
    teamId: string;
    teamName: string | null;
    totalUsed: number;
    usageByType: CreditUsageBreakdown;
};

export type CreditSpendByTeam = {
    teamId: string;
    teamName: string | null;
    totalUsed: number;
    usageByType: CreditUsageBreakdown;
};

export type CreditSpendLeaderboardResponse = {
    byUser: CreditSpendByUser[];
    byTeam: CreditSpendByTeam[];
};

export enum CreditSpendLeaderboardDisplayType {
    Percentage = 'percentage',
    Absolute = 'absolute',
}
